import { Component, Input, OnInit } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {
  ControlContainer,
  UntypedFormBuilder,
  FormControl,
  UntypedFormGroup,
  FormGroupDirective,
} from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { CanvasService } from "@services/canvas.service";
import { CommonService } from "@services/common.service";
import { environment } from "@environments/environment";

@Component({
    selector: "app-quantifiers",
    templateUrl: "./quantifiers.component.html",
    styleUrls: ["./quantifiers.component.scss"],
    viewProviders: [
        { provide: ControlContainer, useExisting: FormGroupDirective },
    ],
    standalone: false
})
export class QuantifiersComponent implements OnInit {
  @Input() currentDataFields!: any;
  @Input() calculationOptions!: any;

  @Input() chartType!: any;

  childForm: any;
  public fieldForm!: UntypedFormGroup;
  public aggregateData: any = [];
  public calculationId: number = 0;

  constructor(
    public parentF: FormGroupDirective,
    private http: HttpClient,
    private fb: UntypedFormBuilder,
    private canvasService: CanvasService,
    public commonService: CommonService,
    public dialog: MatDialog
  ) {}

  buildAggregateData(event: any) {
    this.childForm.get("calculationMethod")!.setValue(event.value);
    const quantifiers = this.commonService.generateQuantifiers(
      this.currentDataFields,
      this.calculationId,
      event.value
    );
    this.childForm.get("quantifierdata")!.setValue(quantifiers);

    // make refresh call and emit the chart data to the parent
    this.canvasService.refreshCanvas(this.childForm).subscribe(
      (success: any) => {
        this.canvasService.triggerEnable();
        const data = success.data;
        this.canvasService.pushChartToStorage(data);
        this.canvasService.populateCanvas(data);
      },
      (error: any) => {
        this.canvasService.triggerEnable();
        const data = this.canvasService.getChartFromStorage();
        this.canvasService.populateCanvas(data);
      }
    );
  }

  initForm() {}

  ngOnChanges() {
    if (this.childForm) {
      this.calculationId = this.childForm.get("calculationId")!.value;
    }
  }
  ngOnInit(): void {
    this.childForm = this.parentF.form;
    this.initForm();
    if (this.childForm) {
      this.calculationId = this.childForm.get("calculationId")!.value;
    }
  }
}
